<!-- =========================================================================================
    File Name: V2HeaderNotifications.vue
    Description: .
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="v2_header_notifications_container">
    <button
      class="v2_header_notification"
      @click="openNotifications"
      :data-notifications="notificationCount"
      :class="{ 'has-notifications': notificationCount > 0 }"
    >
      <vs-icon
        class="text-sm"
        icon-pack="feather"
        icon="icon-bell"
        color="white"
      ></vs-icon>
    </button>

    <v2-popover ref="popover">
      <div class="v2_header_notifications">
        <div class="v2_header_notifications_header">
          <span>Atualizações</span>

          <span
            class="v2_header_notifications_badge"
            v-if="notificationCount > 0"
          >
            {{ notificationCount }}
          </span>
        </div>

        <vs-collapse class="v2_header_notifications_collapse">
          <vs-collapse-item
            :key="index"
            v-for="(notification, index) in notifications"
            class="v2_header_notifications_collapse_item"
          >
            <div slot="header" class="v2_header_notifications_collapse_header">
              <span class="v2_header_notifications_collapse_header_title">
                {{ notification.tituloNota }} - {{ notification.resumoNota }}
              </span>

              <span class="v2_header_notifications_collapse_header_datetime">
                {{ notification.createdAt }}</span
              >
            </div>

            <div class="v2_header_notifications_collapse_content">
              <span>{{ notification.descricaoNota }}</span>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </v2-popover>
  </div>
</template>

<script>
import V2Popover from './V2Popover.vue';

import service from '../../services';

import formatDate from '../utils/formatDate';
import jwt from 'jsonwebtoken';

export default {
  components: {
    V2Popover,
  },

  methods: {
    openNotifications(event) {
      this.$refs.popover.openPopover(event);
    },

    async getNotifications() {
      try {
        const res = await service.getAll('notas-atualizacao', {}, 'obterNotas');
        const newNotifications = res.data.filter((note) => {
          return !this.getStoredNotificationIds().includes(note.idNota);
        });

        const updatedIds = [
          ...this.getStoredNotificationIds(),
          ...newNotifications.map((note) => note.idNota),
        ];
        this.updateStoredNotificationIds(updatedIds);

        this.notifications = res.data
          .filter((note) => this.isValidNotification(note))
          .map((note) => ({
            ...note,
            createdAt: formatDate(note.createdAt),
            isCollapsed: false,
          }));

        this.notificationCount = this.notifications.length;
      } catch (error) {
        throw new Error(error);
      }
    },
    isValidNotification(notification) {
      const resultado = !notification.perfis
        ? this.idEmpresa === notification.empresa
        : (() => {
            const perfis = notification.perfis.split(',').map(Number);
            return (
              this.idEmpresa === notification.empresa &&
              perfis.includes(this.idPerfil)
            );
          })();

      return resultado;
    },

    getStoredNotificationIds() {
      const storedIds = localStorage.getItem('notificationIds');
      return storedIds ? JSON.parse(storedIds) : [];
    },

    updateStoredNotificationIds(newIds) {
      localStorage.setItem('notificationIds', JSON.stringify(newIds));
    },
    async getIdsEmpresaPerfil() {
      const userToken = localStorage.getItem('user-token');
      if (userToken) {
        const { id_empresa, id_perfil } = await jwt.decode(userToken);
        this.idEmpresa = id_empresa;
        this.idPerfil = id_perfil;
      }
    },
  },

  data() {
    return {
      notifications: [],
      notificationCount: 0,
      idEmpresa: null,
      idPerfil: null,
    };
  },

  mounted() {
    this.getIdsEmpresaPerfil();
    this.getNotifications();
  },
};
</script>

<style lang="scss">
@mixin badge {
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background-color: #c8283c;
  border-radius: 100px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 10px;
  line-height: 11px;
  text-align: center;
}

.v2_header_notifications_container {
  position: relative;
  margin-right: 24px;

  @media (max-width: 768px) {
    .v2_popover {
      right: -52px;
    }
  }
}

.v2_header_notifications {
  width: 365px;
  height: 100%;
}

.v2_header_notification {
  position: relative;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 24px;
  background-color: #0c90cf;
  border: 0;
  cursor: pointer;
}

.v2_header_notification.has-notifications::before {
  @include badge;
  content: attr(data-notifications);
  position: absolute;
  top: 0;
  right: -8px;
}

.v2_header_notifications_header {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: #0f4173;
  gap: 10px;
}

.v2_header_notifications_badge {
  @include badge;
}

.v2_header_notifications_collapse {
  padding: 8px;
}

.v2_header_notifications_collapse_item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.v2_header_notifications_collapse_item header {
  padding: 0;
}

.v2_header_notifications_collapse_item .icon-header {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  padding: 4px;
  color: white;
  background-color: #0f4173;
  right: 0;
}

.v2_header_notifications_collapse_item .con-content--item {
  padding: 0 !important;
}

.v2_header_notifications_collapse_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 12px 16px;
  border-radius: 8px;
  gap: 32px;

  &:hover {
    background-color: #d9d9d9;
  }
}

.v2_header_notifications_collapse_header_title {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.25px;
}

.v2_header_notifications_collapse_header_datetime {
  max-width: 54px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  text-align: center;
  margin-right: 36px;
}

.v2_header_notifications_collapse_content {
  max-height: 300px;
  overflow-y: auto;
  padding: 16px;
  border-radius: 8px;
  background-color: #cfdae6;

  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.25px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #082440;
    border-radius: 8px;
    border: 4px solid #082440;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #082440;
  }
}
</style>
